// Routes for the checkout pages. Kept in its own file so page groups can be added independently.
export default [
	{
		path: '/cart',
		component: () => import('../pages/checkout/Bag.vue'),
		meta: { tab: 'bag', title: 'Your Bag | In His Hands Birth Supply' },
	},
	{
		path: '/checkout',
		component: () => import('../pages/checkout/Checkout.vue'),
		meta: { tab: 'bag', tabBar: false, title: 'Checkout | In His Hands Birth Supply' },
	},
	{
		path: '/checkout/order-confirmation/:bcId',
		component: () => import('../pages/checkout/OrderConfirmation.vue'),
		meta: { tab: 'bag', tabBar: false, title: 'Order Confirmation | In His Hands Birth Supply' },
	},
]
